<template>
  <v-container>
    <v-row class="my-1">
      <v-col cols="8" lg="8" md="8" sm="8" xs="8"></v-col>
      <v-col cols="4" lg="4" md="4" sm="4" xs="4">
        <div class="d-flex grow flex-wrap">
          <a @click="$router.back()">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              right
              top
            >
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </a>
        </div>
      </v-col>
    </v-row>
    <v-row justify="space-around">
      <v-col cols="12" md="12" xs="12" class="text-center text-h6">
        <span class="mt-4">{{ fileName }}</span>
      </v-col>
      <v-card
        :style="fileType === 'image' ? 'display:block' : 'display: contents'"
        tile
      >
        <v-img
          v-if="fileType === 'image'"
          :src="filePath"
          cover
          :alt="fileName"
          class="text-white ma-auto"
        />
        <video
          v-if="fileType === 'video'"
          width="80%"
          controls
          controlsList="nodownload"
          class="my-0"
        >
          <source :src="filePath" />
          <track
            label="English"
            kind="subtitles"
            srclang="en"
            src="fgsubtitles_en.vtt"
            default
          />
        </video>
        <audio controlsList="nodownload" v-if="fileType === 'audio'" controls>
          <source :src="filePath" type="audio/mpeg" />
        </audio>
        <pdfCanvas :url="filePath" v-if="fileType === 'doc'"></pdfCanvas>
      </v-card>
    </v-row>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import pdfCanvas from '@/components/Acad/sop/pdf-canvas.vue'
export default {
  name: 'previewMedia',
  props: ['previewId'],
  components: {
    pdfCanvas
  },
  data () {
    return {
      url: '',
      imageExtensionArray: ['jpg', 'png', 'jpeg'],
      videoExtensionArray: ['mov', 'mpg', 'avi', 'mp4', 'wmv', 'm4v'],
      audioExtensionArray: ['mp3'],
      documentExtensionArray: ['pdf'],
      fileType: '',
      filePath: '',
      fileName: '',
      loadingComponent: null
    }
  },
  created: async function () {
    console.log(this.isDownlodable)
    await this.getAwsSignedData(this.previewId)
  },
  methods: {
    async openHandler (pdfApp) {
      this.info = []
      const info = await pdfApp.pdfDocument
        .getMetadata()
        .catch(console.error.bind(console))

      if (!info) return
      const props = Object.keys(info.info)
      props.forEach((prop) => {
        const obj = {
          name: prop,
          value: info.info[prop]
        }
        this.info.push(obj)
      })
    },
    getAwsSignedData: async function (resID) {
      this.loadingComponent = this.$buefy.loading.open()
      try {
        let res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-signed-url/${resID}`
        )
        if (res.status === 200) {
          console.log(res.data)
          this.fileName = res.data.fileName
          this.filePath = res.data.filePath
          this.fileType = await this.checkFileType(res.data.fileType)
        } else {
          return this.$dialog.error({
            text: 'Failed to open file.',
            title: 'Error'
          })
        }
      } catch (e) {
        return this.$dialog.error({
          text: e.response.data.message,
          title: 'Error'
        })
      }
      this.loadingComponent.close()
    },
    checkFileType: function (type) {
      let fileType = ''
      if (this.imageExtensionArray.indexOf(type) !== -1) {
        fileType = 'image'
      } else if (this.videoExtensionArray.indexOf(type) !== -1) {
        fileType = 'video'
      } else if (this.audioExtensionArray.indexOf(type) !== -1) {
        fileType = 'audio'
      } else if (this.documentExtensionArray.indexOf(type) !== -1) {
        fileType = 'doc'
      } else {
        fileType = 'invalid'
      }
      return fileType
    }
  }
}
</script>
